import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button, Form, FormGroup, Label, Input, Alert, Card, CardBody, Row, Col } from 'reactstrap';
import Select from 'react-select';
import { BASE_URL } from '../../../constants';
import { IoMdArrowDropdown, IoMdSettings } from 'react-icons/io';

function EditPropertyLease(props) {
	const [errMsg, setErrMsg] = useState(null);
	const [properties, setProperties] = useState([]);
	const [selectedProperty, setSelectedProperty] = useState({ id: '', name: '' });
	// const [tenants, setTenants] = useState([]);
	const [newRenter, setNewRenter] = useState({
		first_name: '',
		last_name: '',
		email: '',
		phone: ''
	});
	// console.log(newRenter,'newRenter')
	// const [selectedTenant, setSelectedTenant] = useState(null);
	const [leaseStatus, setLeaseStatus] = useState('');
	const [leaseStart, setLeaseStart] = useState('');
	// console.log(selectedProperty, 'selectedProperty')
	// console.log(selectedTenant, 'selectedTenant')
	const [leaseEnd, setLeaseEnd] = useState('');
	const [leaseMoveIn, setLeaseMoveIn] = useState('');
	const [leaseMoveOut, setLeaseMoveOut] = useState('');
	const [leaseSignStatus, setLeaseSignStatus] = useState('');
	const [rent, setRent] = useState('');
	const [comments, setComments] = useState('');
	const navigate = useNavigate();
	const { id } = useParams();
	const location = useLocation();
	// console.log(location.state, id, 'eng')
	const leaseStatusOptions = [
		'LISTED',
		'MOVING_IN',
		'CURRENT',
		'CURRENT_RENEWAL',
		'MOVING_OUT',
		'MOVING_OUT_SD_PENDING',
		'SD_RETURNED',
		'MOVING_IN_ROOMMATE',
		'MOVING_OUT_ROOMMATE',
		'MOVING_OUT_SD_PENDING_ROOMMATE',
		'SD_RETURNED_ROOMMATE'
	];

	const leaseSignStatuses = [
		'No Signatures',
		'Own Notified of Lease/Renewal',
		'Lease/Renewal Sent',
		'Ten Sig - Partial',
		'Ten Sig - Complete',
		'Ten Comp - Sent to Owner',
		'Complete',
	];

	useEffect(() => {
		const token = localStorage.getItem('token');
		if (token) {
			fetch(`${BASE_URL}/property/all`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					if (data.status) {
						setProperties(data.result.map((property) => ({
							name: property.name,
							id: property.id
						})));
					}
					else {
						console.error("Error: Unable to fetch property data.");
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		} else {
			console.error("Error: Authorization token is missing.");
		}
	}, []);

	const formatDate = (dateString) => {
		const [day, month, year] = dateString.split('/');
		return `${year}-${month}-${day}`;
	};


	useEffect(() => {
		const token = localStorage.getItem('token');
		if (token) {
			axios.get(`${BASE_URL}/propertylease/specific/${id}`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
				.then(response => {
					const propertyLeaseData = response.data.result[0];
					if (propertyLeaseData) {
						setSelectedProperty({
							id: propertyLeaseData.property_id,
							name: propertyLeaseData.property_name || ''
						});

						setLeaseStatus(propertyLeaseData.status);

						setLeaseStart(propertyLeaseData.start_date ? propertyLeaseData.start_date.split('T')[0] : '');
						setLeaseEnd(propertyLeaseData.end_date ? propertyLeaseData.end_date.split('T')[0] : '');
						setLeaseMoveIn(propertyLeaseData.move_in_date ? propertyLeaseData.move_in_date.split('T')[0] : '');
						setLeaseMoveOut(propertyLeaseData.move_out_date ? propertyLeaseData.move_out_date.split('T')[0] : '');

						setLeaseSignStatus(propertyLeaseData.sign_status);
						setRent(propertyLeaseData.rent || '');
						setComments(propertyLeaseData.comments);
						// setSelectedTenant({
						//     label: `${propertyLeaseData.tenant_first_name || ''} ${propertyLeaseData.tenant_last_name || ''} - ${propertyLeaseData.tenant_email || ''}`,
						//     value: propertyLeaseData.tenant_id
						// });
						setNewRenter({
							first_name: propertyLeaseData.tenant_first_name || '',
							last_name: propertyLeaseData.tenant_last_name || '',
							email: propertyLeaseData.tenant_email || '',
							phone: propertyLeaseData.tenant_phone || ''
						});
					} else {
						setErrMsg('Error: Property lease data not found.');
					}
				})
				.catch(error => {
					setErrMsg('Error fetching data: ' + error.message);
				});
		} else {
			setErrMsg('Error: Authorization token is missing.');
		}
	}, [id]);

	/*
	const handleTenantSearch = (inputValue) => {
		console.log(inputValue, 'inputValue')
		const token = localStorage.getItem('token');
		if (token) {
			fetch(`${BASE_URL}/tenant/all?q=${inputValue}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					if (data.status) {
						console.log(data, 'data')
						setTenants(data.result.map((tenant) => ({
							label: `${tenant.first_name} ${tenant.last_name} - ${tenant.email}`,
							value: tenant.id
						})));
					} else {
						console.error("Error: Unable to fetch Renter data.");
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		} else {
			console.error("Error: Authorization token is missing.");
		}
	};
	*/

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!selectedProperty.id) {
			setErrMsg('Property is required.');
			return;
		}

		try {
			const token = localStorage.getItem('token');
			if (!token) {
				throw new Error('Authorization token is missing.');
			}

			const response = await axios.put(`${BASE_URL}/propertylease/update/${selectedProperty.id}/${id}`, {
				status: leaseStatus,
				start_date: leaseStart,
				end_date: leaseEnd,
				move_in_date: leaseMoveIn,
				move_out_date: leaseMoveOut,
				sign_status: leaseSignStatus,
				rent,
				comments,
				tenant: newRenter
				// tenant_id: selectedTenant?.value
			}, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			});
			if (response.data.status) {
				navigate('/lease');
			} else {
				setErrMsg(response.data.message);
			}
		} catch (error) {
			setErrMsg(error.message);
		}
	};

	return (
		<div className="content">
			{errMsg && <Alert color="danger">{errMsg}</Alert>}

			<h3>Edit Renter Connection</h3>
			<Card>
				<CardBody>
					<Form onSubmit={handleSubmit}>
						<Row>
							<Col xs="6">
								<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
									<Label for="property">Property*</Label>
									<Input
										type="select"
										name="property"
										id="property"
										value={selectedProperty.name}
										onChange={(e) => {
											const selectedPropertyId = e.target.options[e.target.selectedIndex].getAttribute('data-id');
											setSelectedProperty({ id: selectedPropertyId, name: e.target.value });
										}}
										disabled
									>
										<option value="">Select Property</option>
										{properties.map((property, index) => (
											<option key={index} value={property.name} data-id={property.id}>{property.name}</option>
										))}
									</Input>
								</FormGroup>
							</Col>
							<Col xs="6">
								<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
									<Label for="leaseStatus">Renter Status*</Label>
									<Input type="select" name="leaseStatus" id="leaseStatus" value={leaseStatus} onChange={(e) => setLeaseStatus(e.target.value)}>
										<option value="">Select Renter Status</option>
										{leaseStatusOptions.map((status, index) => {
											const formattedStatus = status.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
											return <option key={index} value={status}>{formattedStatus}</option>;
										})}
									</Input>
								</FormGroup>
							</Col>
						</Row>

						<Row>
							<Col xs="6">
								<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
									<Label for="firstName">Renter First Name*</Label>
									<Input
										type="text"
										id="firstName"
										value={newRenter.first_name}
										onChange={(e) => setNewRenter({ ...newRenter, first_name: e.target.value })}
									/>
								</FormGroup>
							</Col>
							<Col xs="6">
								<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
									<Label for="lastName">Renter Last Name*</Label>
									<Input
										type="text"
										id="lastName"
										value={newRenter.last_name}
										onChange={(e) => setNewRenter({ ...newRenter, last_name: e.target.value })}
									/>
								</FormGroup>
							</Col>
							<Col xs="6">
								<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
									<Label for="email">Renter Email*</Label>
									<Input
										type="email"
										id="email"
										value={newRenter.email}
										disabled
										onChange={(e) => setNewRenter({ ...newRenter, email: e.target.value })}
									/>
								</FormGroup>
							</Col>
							<Col xs="6">
								<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
									<Label for="phone">Renter Phone</Label>
									<Input
										type="number"
										id="phone"
										value={newRenter.phone}
										onChange={(e) => setNewRenter({ ...newRenter, phone: e.target.value })}
									/>
								</FormGroup>
							</Col>
						</Row>


						<Row>
							<Col xs="6">
								<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
									<Label for="leaseMoveIn">Move In</Label>
									<Input type="date" name="leaseMoveIn" id="leaseMoveIn" value={leaseMoveIn} onChange={(e) => setLeaseMoveIn(e.target.value)} />
								</FormGroup>
							</Col>
							<Col xs="6">
								<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
									<Label for="leaseMoveOut">Move Out</Label>
									<Input type="date" name="leaseMoveOut" id="leaseMoveOut" value={leaseMoveOut} onChange={(e) => setLeaseMoveOut(e.target.value)} />
								</FormGroup>
							</Col>
						</Row>

						<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
							<Label for="comments">Notes</Label>
							<Input type="textarea" name="comments" id="comments" value={comments} onChange={(e) => setComments(e.target.value)} />
						</FormGroup>
						

						<Button color="primary" type="submit">Submit</Button>
					</Form>
				</CardBody>
			</Card>
		</div>
	);
}

export default EditPropertyLease;
